<template>
  <lb-drawer
    :value="visible"
    @input="$emit('update:visible', $event)"
    :heading="`Select ${botName} to bulk link`"
    :width="drawerWidths.md"
    persistent
    v-if="visible"
    data-testid="tasklist__bulk-link-bot-drawer"
  >
    <template v-slot:body>
      <div class="link-bot-drawer__body">
        <LinkBotAgentSelect
          :value="selectedBot"
          :bot-list="botList"
          :bot-name="botName"
          data-testid="tasklist__bulk-link-bot-dropdown"
          @input="$emit('update:selectedBot', $event)"
        />

        <div
          v-if="selectedBot === 'Lease Schedule'"
          class="link-bot-drawer__section"
          data-testid="tasklist__bulk-link-lease-schedule-title"
        >
          <p class="link-bot-drawer__section-label">Select {{ botName }} result(s)</p>

          <div
            v-for="(task, taskIndex) in selectedTasks"
            :key="task._id || taskIndex"
            class="link-bot-drawer__bulk-task-block"
            data-testid="tasklist__bulk-link-lease-schedule-items"
          >
            <p class="link-bot-drawer__bulk-task-label">
              {{ task.ref || task.description || `Task ${taskIndex + 1}` }}
            </p>
            <div class="link-bot-drawer__lease-options">
              <v-checkbox
                v-for="(lease, index) in leaseScheduleItems || []"
                :key="`${task._id || taskIndex}-${lease || 'lease'}-${index}`"
                color="caccounting"
                :label="lease"
                dense
                class="link-bot-drawer__lease-item"
                :input-value="(leaseScheduleBulkValue[task._id] || []).includes(lease)"
                hide-details
                data-testid="tasklist__bulk-link-lease-schedule-checkbox"
                @change="toggleLeaseSchedule(task._id, lease, $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:actions>
      <LinkBotDrawerActions
        primary-label="Submit"
        data-testid="tasklist__bulk-link-bot"
        @cancel="closeDrawer"
        @submit="$emit('submit')"
      />
    </template>
  </lb-drawer>
</template>

<script>
import { drawerWidths } from '../../../../../../../styles/design-tokens.js';
import LinkBotAgentSelect from '../shared/LinkBotAgentSelect.vue';
import LinkBotDrawerActions from '../shared/LinkBotDrawerActions.vue';
import '../shared/LinkBotDrawer.scss';

export default {
  name: 'BulkLinkBotDrawer',

  components: {
    LinkBotAgentSelect,
    LinkBotDrawerActions,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    botName: {
      type: String,
      default: '',
    },
    selectedBot: {
      type: String,
      default: '',
    },
    botList: {
      type: Array,
      default: () => [],
    },
    selectedTasks: {
      type: Array,
      default: () => [],
    },
    leaseScheduleItems: {
      type: Array,
      default: () => [],
    },
    leaseScheduleBulkValue: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    drawerWidths: () => drawerWidths,
  },

  methods: {
    closeDrawer() {
      this.$emit('update:visible', false);
    },

    toggleLeaseSchedule(taskId, lease, checked) {
      const current = [...(this.leaseScheduleBulkValue[taskId] || [])];
      if (checked && !current.includes(lease)) {
        current.push(lease);
      } else if (!checked) {
        const idx = current.indexOf(lease);
        if (idx > -1) current.splice(idx, 1);
      }
      this.$emit('update:leaseScheduleBulkValue', {
        ...this.leaseScheduleBulkValue,
        [taskId]: current,
      });
    },
  },
};
</script>
